import { getApiClient } from './ApiClient'

export const mealListPromise = (params) => {
  return getApiClient()
    .get('/meals', {
      params
    })
    .then(resp => {
      return Promise.resolve(resp.data)
    })
}

export const mealDetailPromise = (id) => {
  return getApiClient()
    .get(`/meals/${id}`)
    .then(resp => {
      return Promise.resolve(resp.data)
    })
}

export const mealUpsertPromise = (body) => {
  return getApiClient()
    .post('/meals/upsert', {
      body
    })
    .then(resp => {
      return Promise.resolve(resp.data)
    })
}
